export default __webpack_public_path__ + "static/media/inspi1.1ea9e2b3.jpg";